import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Asterisk } from "lucide-react";

interface NameFieldProps {
  control: Control<any>;
}

export function NameField({ control }: NameFieldProps) {
  const { t } = useTranslation();
  
  return (
    <FormField
      control={control}
      name="full_name"
      render={({ field }) => (
        <FormItem>
          <div className="flex items-center gap-2">
            <FormLabel>{t('profile.personalInfo.fullName')}</FormLabel>
            <Asterisk className="h-3 w-3 text-red-500" />
          </div>
          <FormControl>
            <Input {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}